import PropTypes from "prop-types";
import React from "react";
import { Navbar, Nav, NavItem, NavDropdown, Glyphicon } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";

import FeatureFlagStore from "../stores/FeatureFlagStore";
import UserStore from "../stores/UserStore";

import { ApplicationPaths } from "./api-authorization/ApiAuthorizationConstants";
import AuthorizeService from "./api-authorization/AuthorizeService";

class AppNavigation extends React.Component
{
	constructor(props)
	{
		super(props);
		const state = { authenticated: false, isPremiumUser: false, isAdminUser: false };
		state.expanded = false;
		this.state = state;

		this.handleCollapseMenu = this.handleCollapseMenu.bind(this);
		this.handleHangfire = this.handleHangfire.bind(this);
	}

	handleCollapseMenu()
	{
		this.setState({ expanded: false });
	}

	async handleHangfire()
	{
		const tokenAsCookie = await AuthorizeService.getTokenAsCookie();
		document.cookie = tokenAsCookie;
		window.location.href = "/hangfire";
	}

	componentDidMount()
	{
		this.makeRemoteRequest();
	}

	async makeRemoteRequest()
	{
		const authenticated = await AuthorizeService.isAuthenticated();
		const isPremiumUser = await AuthorizeService.isPremiumUser();
		const isAdminUser = await AuthorizeService.isAdminUser();
		this.setState({authenticated, isPremiumUser, isAdminUser});
	}

	render()
	{
		const premiumAccountEnabled = FeatureFlagStore.premiumAccountEnabled();
		const importEnabled = FeatureFlagStore.importEnabled();
		const contactUsEnabled = FeatureFlagStore.contactUsEnabled();
		const {authenticated, isPremiumUser, isAdminUser} = this.state;
		const expanded = this.state.expanded;
		const areMultipleCurrenciesEnabled = UserStore.areMultipleCurrenciesEnabled();
		const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };

		return (
			<div>
				<Navbar expanded={expanded} onToggle={() => this.setState({expanded: !expanded})}>
					<Navbar.Header>
						<Navbar.Brand>
							<Link to="/">BudgetMeister</Link>
						</Navbar.Brand>
						<Navbar.Toggle />
					</Navbar.Header>
					<Navbar.Collapse>
						<Nav>
							<LinkContainer to="/transactions" onClick={this.handleCollapseMenu}>
								<NavItem>Transactions</NavItem>
							</LinkContainer>
							{importEnabled &&
								<LinkContainer to="/import" onClick={this.handleCollapseMenu}>
									<NavItem>Import</NavItem>
								</LinkContainer>
							}
							<NavDropdown title="Budget" id="budget-dropdown">
								<LinkContainer to="/budget" onClick={this.handleCollapseMenu}>
									<NavItem>Budget</NavItem>
								</LinkContainer>
								<LinkContainer to="/budgettemplates" onClick={this.handleCollapseMenu}>
									<NavItem>Templates</NavItem>
								</LinkContainer>
							</NavDropdown>
						</Nav>
						<Nav pullRight>
							<NavDropdown
								title={
									<Glyphicon glyph={"cog"} />
								}
								id="settings-dropdown"
							>
								{authenticated &&
									<LinkContainer to="/accounts" onClick={this.handleCollapseMenu}>
										<NavItem>Accounts</NavItem>
									</LinkContainer>
								}
								{authenticated &&
									<LinkContainer to="/settings" onClick={this.handleCollapseMenu}>
										<NavItem>Settings</NavItem>
									</LinkContainer>
								}
								{authenticated &&
									<LinkContainer to="/categories" onClick={this.handleCollapseMenu}>
										<NavItem>Categories</NavItem>
									</LinkContainer>
								}
								{authenticated && isPremiumUser && areMultipleCurrenciesEnabled &&
									<LinkContainer to="/currencies" onClick={this.handleCollapseMenu}>
										<NavItem>Currencies</NavItem>
									</LinkContainer>
								}
								{authenticated &&
									<LinkContainer to="/tags" onClick={this.handleCollapseMenu}>
										<NavItem>Tags</NavItem>
									</LinkContainer>
								}
								{authenticated &&
									<NavItem onClick={this.props.handleShowHelp}>Hotkeys</NavItem>
								}
								{premiumAccountEnabled && authenticated && !isPremiumUser &&
									<LinkContainer to="/upgrade" onClick={this.handleCollapseMenu}>
										<NavItem>Upgrade</NavItem>
									</LinkContainer>
								}
								{premiumAccountEnabled && authenticated && isPremiumUser &&
									<LinkContainer to="/subscription" onClick={this.handleCollapseMenu}>
										<NavItem>Subscription</NavItem>
									</LinkContainer>
								}
								{contactUsEnabled &&
									<LinkContainer to="/contactus" onClick={this.handleCollapseMenu}>
										<NavItem>Contact us</NavItem>
									</LinkContainer>
								}
								{authenticated && isAdminUser &&
									<NavItem onClick={this.handleHangfire}>Hangfire</NavItem>
								}
								{authenticated ?
									<LinkContainer to={logoutPath} onClick={this.handleCollapseMenu}>
										<NavItem>Logout</NavItem>
									</LinkContainer>
									:
									<LinkContainer to="/login" onClick={this.handleCollapseMenu}>
										<NavItem>Login</NavItem>
									</LinkContainer>
								}
							</NavDropdown>
						</Nav>
					</Navbar.Collapse>
				</Navbar>
			</div>
		);
	}
}

AppNavigation.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func
	}),
	handleShowHelp: PropTypes.func
};

export default AppNavigation;



// WEBPACK FOOTER //
// ./Components/components/AppNavigation.jsx